import Box from "@mui/material/Box";
import Chip from "@mui/material/Chip";
import { RefreshCw } from "lucide-mui";
import { formatNumber } from "../utils/format.ts";

interface LiveUpdatesPillProps {
  /** Rows the server has that the held list doesn't show yet. */
  pendingNew: number;
  /** Rows gone from the server, still shown dimmed. */
  pendingRemoved: number;
  onApply: () => void;
}

/**
 * Over a held live list (`useLiveList`): "3 new · Show" brings in what changed
 * on the server since it froze. Pass it as the `TableCard`'s `notice`; it
 * floats at the top of the card while the rows scroll. Nothing when nothing changed.
 */
export default function LiveUpdatesPill({ pendingNew, pendingRemoved, onApply }: LiveUpdatesPillProps) {
  if (!pendingNew && !pendingRemoved) return null;
  const label = pendingNew ? `${formatNumber(pendingNew)} new` : `${formatNumber(pendingRemoved)} updated`;
  return (
    // No height: it floats over the header row instead of pushing the rows down.
    <Box
      role="status"
      sx={{ position: "sticky", top: 12, zIndex: 3, height: 0, display: "flex", justifyContent: "center" }}
    >
      <Chip
        color="primary"
        size="small"
        icon={<RefreshCw />}
        label={`${label} · Show`}
        onClick={onApply}
        sx={{ mt: 0.75, boxShadow: 3 }}
      />
    </Box>
  );
}
